import React from 'react'
import { Typography } from '@material-ui/core'
import './styles/social-media-provider.css'
import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'
import { SOCIAL_PROVIDER_KEY_FACEBOOK } from '../../configs/socialMediaIntegrationConfig'

export default function SocialMediaProvider({
  imgPath,
  nameTranslationId,
  descriptionTranslationId,
  connected,
  onClick,
  onButtonClick,
  providerKey,
  comingSoon,
}) {
  const { formatMessage } = useIntl()
  const buttonClasses = clsx('social-media-provider-button', {
    'social-media-provider-button-connect': !connected,
    'social-media-provider-button-disconnect': connected,
  })
  const provider = {
    imgPath,
    nameTranslationId,
    descriptionTranslationId,
    connected,
    onButtonClick,
    onClick,
    providerKey,
    comingSoon,
  }

  return (
    <div
      className={clsx('social-media-provider', {
        'social-media-provider-connected': !provider.connected,
        'social-media-provider-coming-soon': provider.comingSoon,
      })}
    >
      <div className="social-media-provider-image-block">
        <img
          src={imgPath}
          alt={formatMessage({ id: nameTranslationId })}
          className="social-media-provider-image"
        />
      </div>
      <div className="social-media-provider-info-block">
        <Typography variant="h6" className="social-media-provider-title">
          <FormattedMessage id={nameTranslationId} />
        </Typography>
      </div>
      <button className={buttonClasses} onClick={() => onButtonClick(provider)}>
        {connected ? (
          <FormattedMessage
            id={
              'socialMediaIntegrations.provider.button.disconnect.placeholder'
            }
          />
        ) : (
          <FormattedMessage
            id={'socialMediaIntegrations.provider.button.connect.placeholder'}
          />
        )}
      </button>

      {providerKey === SOCIAL_PROVIDER_KEY_FACEBOOK && connected && (
        <button
          className="social-media-provider-button social-media-provider-button-manage-page"
          onClick={(e) => onClick(e, provider)}
        >
          <FormattedMessage
            id={
              'socialMediaIntegrations.provider.button.managePage.placeholder'
            }
          />
        </button>
      )}
    </div>
  )
}
